module.exports = __webpack_public_path__ + "static/img/YKK_H5.accea04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/YKK_H5.png
// module id = joB0
// module chunks = 34